import { MediaTailorTrackingResponse } from './AdMetadata';
import { Error } from '@quickplay/foundation';
import { AdTrackingUpdateMode } from './DatazoomAdMetaData';

export interface MediatailorMetadata {
  manifestUrl: string;
  isFallback?: boolean;
  fallbackReason?: Error;
  trackingUrl?: string;
  adMetadata?: MediaTailorTrackingResponse;
  adSessionId?: string;
}

export interface MediatailorSessionConfiguration {
  /**
   * Key-value pairs that MediaTailor can read and send to the ad server in all session requests.
   */
  adsParams?: { [key: string]: any };
  /**
   * Preceding configuration used for session initialization request that defines the player variables and their aliases.
   */
  playerParams?: { [key: string]: any };
  /**
   * Query parameters included in the parent manifest and tracking URLs in the response.
   */
  manifestParams?: { [key: string]: any };
  /**
   * MediaTailor support for overlay ads is enabled by default.
   * A specific SCTE-35 ad-marker type in the manifest triggers the insertion of an overlay ad.
   * Because some players might not support client-side rendering of overlay ads, you can disable the feature at the session level.
   */
  overlayAvails?: OverlayAvailsMode;
  /**
   * MediaTailor supports a hybrid mode for session tracking. In this mode, the service emits playback-
   * related ad-tracking events, but makes the complete client-side tracking payload available for the
   * session.
   */
  reportingMode?: ReportingMode;
  /**
   * availSuppression
   */
  availSuppression?: AvailSuppression;
  /**
   * To enable ad ID signaling, add an adSignaling object as a top level object, and inside,
   * add a parameter called enabled and value of true. The default adSignaling value is
   * disabled.
   */
  adSignaling?: boolean;
  /**
   * custom origin parameters for the session.
   */
  originParams?: { [key: string]: any };
  /**
   * Datazoom configuration ID.
   * Practically required for mediatailor session creation.
   */
  configId?: string;

  /**
   * Controls how ad tracking metadata updates are requested from Datazoom MediaTailor.
   */
  liveAdTrackingMode?: AdTrackingUpdateMode;

  /**
   * Enabling log mode will log all the MediaTailor session events to cloud watch.
   */
  logMode?: LogMode;

  /**
   * To include additional MediaTailor feature settings for the session.
   */
  extra?: { [key: string]: any };
}

export enum LogMode {
  DEBUG = 'DEBUG',
}

export enum OverlayAvailsMode {
  ON = 'on',
  OFF = 'off',
}
export enum ReportingMode {
  SERVER = 'server',
  CLIENT = 'client',
}

export enum AvailSuppressionMode {
  OFF = 'OFF',
  BEHIND_LIVE_EDGE = 'BEHIND_LIVE_EDGE',
  AFTER_LIVE_EDGE_FULL_AVAIL_ONLY = 'AFTER_LIVE_EDGE_FULL_AVAIL_ONLY',
  AFTER_LIVE_EDGE_PARTIAL_AVAIL = 'AFTER_LIVE_EDGE_PARTIAL_AVAIL',
}

export interface AvailSuppression {
  mode: AvailSuppressionMode;
  value: string;
}
